// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__5zBoB","tab":"tabs_tab__czToG","active":"tabs_active__3vkOI"};